export function BannerQuery(url: string) {
  return /* GraphQL */ `
  query pageQuery {
    pageCollection(where: { url: "${url}" }, limit: 1) {
      items {
        banner {
          __typename
          ...genericBanner
          ...productBanner
        }
      }
    }
  }

  fragment genericBanner on GenericBanner {
    textBoxWidth
    title {
      ...titleText
    }
    image {
      url
      width
      height
      title
    }
    imageMobile {
      url
      width
      height
      title
    }
    mode
    ratesVisible
    rateType
    ratesAlignmentMobile
    ratesAlignmentDesktop
    backgroundColor
    backgroundSizeMobile
    backgroundSizeDesktop
    backgroundRepeatMobile
    backgroundRepeatDesktop
    backgroundPositionMobile
    backgroundPositionDesktop
    backgroundImageMobile {
      url
      width
      height
      title
    }
    backgroundImageDesktop {
      url
      width
      height
      title
    }
    eyebrow {
      ...eyebrow
    }
    text {
      ...titleText
    }
    ctaVisible
    ctaAlignment
    ctaType
    cta {
      ...cta
    }
    ctaFunnel {
      ...funnelButton
    }
    trustPilotVisible
    backgroundDesktop
    backgroundMobile
    isVideo
    videoModalCollection(limit: 6) {
      items {
        ...videoModal
      }
    }
    relatedVideoText {
      ...titleText
    }
    showImgOnMobile
    backBtnBg
    backBtnColor
    backText {
      ...titleText
    }
    videoCta {
      ...cta
    }
  }

  fragment productBanner on ProductBanner {
    banner {
      ...genericBanner
    }
    mode
    tabsCollection(limit: 4) {
      items {
        ...productBannerTab
      }
    }
  }

  fragment productBannerTab on ProductBannerTab {
    name
    icon
    contentCollection(limit: 4) {
      items {
        ...productBannerTabContent
      }
    }
    powerUp {
      ...powerup
    }
    eyebrow {
      ...eyebrow
    }
    title {
      ...titleText
    }
    text {
      ...text
    }
    tabMode
    ctaType
    cta {
      ...cta
    }
    bgColor
    ctaVisible
    desktopControlsOrder
    mobileControlsOrder
  }

  fragment productBannerTabContent on ProductBannerTabContent {
    bgColor
    mode
    emoji
    tabName
    eyebrow {
      ...eyebrow
    }
    displayMode
    contentTitle {
      ...titleText
    }
    contentText {
      ...text
    }
    cta {
      ...cta
    }
    ctaType
    ctaVisible
    listCta {
      ...cta
    }
    listCtaType
    listCtaVisible
    listTitle {
      ...titleText
    }
    listText {
      ...text
    }
    list
    desktopImage {
      url
      width
      height
      title
    }
    mobileImage {
      url
      width
      height
      title
    }
    mobileContentDirection
    desktopContentDirection
  }

  fragment powerup on Powerup {
    basicFeatures
    extrasFeatures
    basicTitle
    basicSubtitle
    basicQuestion
    basicCtaText
    featuresTitle
    basicCta {
      ...cta
    }
    extrasTitle
    extrasSubtitle
    extrasQuestion
    extrasCtaText
    extrasCta {
      ...cta
    }
  }

  fragment BannerVideo on BannerVideo {
    src {
      url
      width
      height
    }
    href
    title
    boxVideo
  }

  fragment eyebrow on EyeBrow {
    desktopAlignment
    mobileAlignment
    icon
    marginBottom
    children
    type
    mode
  }

  fragment titleText on TitleText {
    desktopAlignment
    mobileAlignment
    marginBottom
    size
    markdown: children
    mode
  }

  fragment text on Text {
    desktopAlignment
    mobileAlignment
    marginBottom
    size
    markdown: children
    mode
  }

  fragment cta on Button {
    children
    icon
    iconSize
    href
    mode
    size
    type
  }

  fragment funnelButton on FunnelButton {
    children
    type
    size
    url
  }

  fragment videoModal on VideoModal {
    introTitle {
      ...titleText
    }
    introText {
      ...text
    }
    videoModalActive {
      ...videoModalActive
    }
    vid {
      ...BannerVideo
    }
    backgroundImage {
      url
      title
      width
      height
    }
    anchorId
  }

  fragment videoModalActive on VideoModalActive {
    text {
      ...text
    }
  }
  `;
}
